import React from "react";

import clsx from "clsx";
import { useToasts } from "react-toast-notifications";

import { IconButton, SecondaryButton } from "@shared/buttons";

export interface TrackingScriptCardProps {
  displayName: string;
  scriptCode: string;
  descriptionHTML: React.ReactElement;
  header: string;
  startExpanded?: boolean;
}

export function TrackingScriptCard({
  header,
  descriptionHTML,
  displayName,
  scriptCode,
  startExpanded,
}: TrackingScriptCardProps) {
  const { addToast } = useToasts();
  const [expanded, setExpanded] = React.useState(startExpanded || false);

  return (
    <div className="mt-5">
      <p className="text-[#2b3674]">
        <b>{header}</b>
      </p>
      <div className="card my-3 rounded">
        <div
          className="card-header"
          style={{ cursor: "pointer" }}
          onClick={() => setExpanded(!expanded)}
        >
          <b>{displayName}</b>&nbsp;(click to {expanded ? "hide" : "show"})
        </div>
        <div
          className={clsx(
            { "card-body": true, "d-none": !expanded },
            "flex flex-col gap-3",
          )}
        >
          <p className="card-text">
            <textarea
              style={{ height: "10em", fontFamily: "monospace" }}
              className="form-control"
              readOnly
              value={scriptCode}
            />
          </p>
          <div className="card-text">
            <IconButton
              variant="primary"
              leftIcon={
                <i className="fa-sharp fa-regular fa-link mr-1.5 text-sm" />
              }
              className="font-bold"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(scriptCode);
                  addToast("Copied to clipboard!", { appearance: "success" });
                } catch (err) {
                  addToast("Error while coping to clipboard!", {
                    appearance: "error",
                  });
                }
              }}
            >
              COPY TO CLIPBOARD
            </IconButton>
          </div>
          <div className="card-text ">{descriptionHTML}</div>
          {expanded ? (
            <SecondaryButton onClick={() => setExpanded(!expanded)}>
              CLICK TO HIDE
            </SecondaryButton>
          ) : null}
        </div>
      </div>
    </div>
  );
}
